/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Card } from 'antd';
import CreateCategoryTutorial from 'components/CategoryTutorial/create.categoryTutorial';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const CategoryTutorialCreatePage = () => {
   const location = useLocation();
   const locationSplit = location?.pathname.split('/');
   let id = null;
   if (location?.pathname.includes('edit')) {
      id = Number(locationSplit[4]);
   }

   return (
      <Fragment>
         <Helmet>
            <title>{id ? 'แก้ไขข้อมูลหมวดหมู่วีดีโอ' : 'สร้างข้อมูลหมวดหมู่วีดีโอ' }</title>
         </Helmet>
         <HasAccess
            roles={['Masteradmin']}
            permissions={['category-create']}
            renderAuthFailed={<ErrorPage404 />}
         >
            <Card title={`${id ? 'แก้ไขข้อมูลหมวดหมู่วีดีโอ' : 'สร้างข้อมูลหมวดหมู่วีดีโอ' }`}>
               <CreateCategoryTutorial id={Number(id)}/>
            </Card>
         </HasAccess>
      </Fragment>
   );
};

export default CategoryTutorialCreatePage;
